import React from 'react';
import { motion } from 'framer-motion';
import { TartaEmblem } from './TartaEmblem';
import { OrderButton } from './OrderButton';
import { AmbientLight } from './AmbientLight';
import { useLanguage } from '../context/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section className="py-40 lg:py-56 bg-texture-espresso text-cream relative overflow-hidden border-t border-cream/5" data-id="element-73" data-mp="84xl8i8cy51p">
      <AmbientLight variant="center" seam data-id="element-74" data-mp="m3nhxwr9m2pj" />
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 1.2
    }} className="relative z-10 max-w-[1200px] mx-auto px-8 lg:px-14 text-center flex flex-col items-center" data-id="element-75" data-mp="m2lx50kg61um">
        <TartaEmblem size={88} variant="dark" withTagline circleLight className="ring-1 ring-cream/20 mb-12" data-id="element-76" data-mp="zwmxfyr1rwx3" />

        <div className="flex items-center justify-center gap-4 text-[10px] tracking-[0.5em] uppercase text-caramel mb-10" data-id="element-77" data-mp="2c6rc6bq0skpp">
          <span className="w-12 h-px bg-caramel/40" data-id="element-78" data-mp="2m342czmcwgfp" />
          <span className="font-serif italic normal-case tracking-[0.1em] text-[13px]" data-id="element-79" data-mp="2m19htmezyqc5">
            {t.finalCTA.edition}
          </span>
          <span className="w-12 h-px bg-caramel/40" data-id="element-80" data-mp="2v3io2038fxjq" />
        </div>

        <h2 className="font-serif font-light leading-[0.9] tracking-[-0.035em]" style={{
        fontSize: 'clamp(64px, 11vw, 180px)'
      }} data-id="element-81" data-mp="2v38ygdm3nsek">
          {t.finalCTA.title1}
          <br data-id="element-82" data-mp="34vexg7arra39" />
          <span className="italic font-extralight" data-id="element-83" data-mp="39sf4akfg0gvf">{t.finalCTA.title2}</span>
          <br data-id="element-84" data-mp="39uhsr00y61y1" />
          {t.finalCTA.title3}
          <span className="text-caramel" data-id="element-85" data-mp="3esayjryc8txs">.</span>
        </h2>

        <p className="mt-16 font-serif italic text-cream/65 leading-[1.6] text-xl lg:text-2xl max-w-xl mx-auto" data-id="element-86" data-mp="3epotq02u0sj9">
          {t.finalCTA.copy1}
          <br data-id="element-87" data-mp="1jnjwpshlj2ls" />
          {t.finalCTA.copy2}
        </p>

        <OrderButton withSub className="mt-16" data-id="element-88" data-mp="1jlz2k3z71log" />

        <a href="#waitlist" className="group mt-10 inline-flex items-center gap-6 text-cream" data-id="element-89" data-mp="1eqbfbu49v2ll">
          <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-90" data-mp="1shycdw61gf5f" />
          <span className="font-serif italic text-[15px] tracking-[0.05em]" data-id="element-91" data-mp="1no3umy9zua8z">
            {t.finalCTA.cta}
          </span>
          <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-92" data-mp="1xg04f6lfzot1" />
        </a>
      </motion.div>
    </section>;
}